import { jsx, jsxs } from "react/jsx-runtime";
import { useState } from "react";
import {
  Button,
  H5,
  Separator,
  SizableText,
  Tabs,
  XStack,
  YStack,
  isWeb
} from "tamagui";
const demos = ["horizontal", "vertical"];
const demosTitle = {
  horizontal: "Horizontal",
  vertical: "Vertical"
};
function TabsDemo() {
  const [demoIndex, setDemoIndex] = useState(0);
  const demo = demos[demoIndex];
  return (
    // web only fix for position relative
    /* @__PURE__ */ jsxs(
      YStack,
      {
        paddingHorizontal: "$4",
        ...isWeb && {
          position: "unset"
        },
        children: [
          demo === "horizontal" ? /* @__PURE__ */ jsx(HorizontalTabs, {}) : /* @__PURE__ */ jsx(VerticalTabs, {}),
          /* @__PURE__ */ jsx(
            XStack,
            {
              alignItems: "center",
              space: true,
              position: "absolute",
              bottom: "$3",
              left: "$4",
              $xxs: { display: "none" },
              children: /* @__PURE__ */ jsx(Button, { size: "$2", onPress: () => setDemoIndex((x) => (x + 1) % demos.length), children: demosTitle[demo] })
            }
          )
        ]
      }
    )
  );
}
const HorizontalTabs = () => {
  return /* @__PURE__ */ jsxs(
    Tabs,
    {
      defaultValue: "tab1",
      orientation: "horizontal",
      flexDirection: "column",
      width: 400,
      height: 150,
      borderRadius: "$4",
      borderWidth: "$0.25",
      overflow: "hidden",
      borderColor: "$borderColor",
      children: [
        /* @__PURE__ */ jsxs(
          Tabs.List,
          {
            separator: /* @__PURE__ */ jsx(Separator, { vertical: true }),
            disablePassBorderRadius: "bottom",
            "aria-label": "Manage your account",
            children: [
              /* @__PURE__ */ jsx(Tabs.Tab, { flex: 1, value: "tab1", children: /* @__PURE__ */ jsx(SizableText, { fontFamily: "$body", children: "Profile" }) }),
              /* @__PURE__ */ jsx(Tabs.Tab, { flex: 1, value: "tab2", children: /* @__PURE__ */ jsx(SizableText, { fontFamily: "$body", children: "Connections" }) }),
              /* @__PURE__ */ jsx(Tabs.Tab, { flex: 1, value: "tab3", children: /* @__PURE__ */ jsx(SizableText, { fontFamily: "$body", children: "Notifications" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Separator, {}),
        /* @__PURE__ */ jsx(TabsContent, { value: "tab1", children: /* @__PURE__ */ jsx(H5, { children: "Profile" }) }),
        /* @__PURE__ */ jsx(TabsContent, { value: "tab2", children: /* @__PURE__ */ jsx(H5, { children: "Connections" }) }),
        /* @__PURE__ */ jsx(TabsContent, { value: "tab3", children: /* @__PURE__ */ jsx(H5, { children: "Notifications" }) })
      ]
    }
  );
};
const VerticalTabs = () => {
  return /* @__PURE__ */ jsxs(
    Tabs,
    {
      defaultValue: "tab1",
      flexDirection: "row",
      orientation: "vertical",
      width: 400,
      borderRadius: "$4",
      borderWidth: "$0.25",
      overflow: "hidden",
      borderColor: "$borderColor",
      children: [
        /* @__PURE__ */ jsxs(
          Tabs.List,
          {
            disablePassBorderRadius: "end",
            "aria-label": "Manage your account",
            separator: /* @__PURE__ */ jsx(Separator, {}),
            children: [
              /* @__PURE__ */ jsx(Tabs.Tab, { value: "tab1", children: /* @__PURE__ */ jsx(SizableText, { children: "Profile" }) }),
              /* @__PURE__ */ jsx(Tabs.Tab, { value: "tab2", children: /* @__PURE__ */ jsx(SizableText, { children: "Connections" }) }),
              /* @__PURE__ */ jsx(Tabs.Tab, { value: "tab3", children: /* @__PURE__ */ jsx(SizableText, { children: "Notifications" }) })
            ]
          }
        ),
        /* @__PURE__ */ jsx(Separator, { vertical: true }),
        /* @__PURE__ */ jsx(TabsContent, { value: "tab1", children: /* @__PURE__ */ jsx(H5, { textAlign: "center", children: "Profile" }) }),
        /* @__PURE__ */ jsx(TabsContent, { value: "tab2", children: /* @__PURE__ */ jsx(H5, { textAlign: "center", children: "Connections" }) }),
        /* @__PURE__ */ jsx(TabsContent, { value: "tab3", children: /* @__PURE__ */ jsx(H5, { textAlign: "center", children: "Notifications" }) })
      ]
    }
  );
};
const TabsContent = (props) => {
  return /* @__PURE__ */ jsx(
    Tabs.Content,
    {
      backgroundColor: "$background",
      padding: "$2",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      borderColor: "$background",
      borderRadius: "$2",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderWidth: "$2",
      ...props,
      children: props.children
    },
    "tab3"
  );
};
export {
  TabsDemo
};
//# sourceMappingURL=TabsDemo.js.map
